import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { TemplatePermissions } from '../interfaces'
import { capitalizeFirstLetterOfWord } from '../../../utils/StringUtils'
import { useTranslation } from 'react-i18next'

interface SettingPermisonsProps {
    templatePermissions: TemplatePermissions
    setTemplatePremissions: (templatePermissions: TemplatePermissions) => void
}

const SettingPermisons: React.FC<SettingPermisonsProps> = ({
    templatePermissions,
    setTemplatePremissions,
}) => {
    const { t } = useTranslation()
    const onChangePermissions = (
        role: string,
        permissionKey: string,
        value: boolean,
    ) => {
        const updatedPermissions: TemplatePermissions = {
            ...templatePermissions,
            [role]: {
                ...templatePermissions[role],
                [permissionKey]: value,
            },
        }
        setTemplatePremissions(updatedPermissions)
    }

    return (
        <Box style={{ marginTop: '25px' }}>
            {Object.entries(templatePermissions).map(([role, items]) => (
                <Box key={role} sx={{ mb: 2 }}>
                    <Typography
                        sx={{
                            fontWeight: '600',
                            fontSize: '14px',
                            marginBottom: '5px',
                        }}
                    >
                        {capitalizeFirstLetterOfWord(t(`${role}`))}
                    </Typography>
                    <Box display="flex" gap="5px" sx={{ marginTop: '20px' }}>
                        {Object.entries(items).map(([key, value]) => (
                            <Box key={`setting-permissions-${role}-${key}`}>
                                <FormControlLabel
                                    label={capitalizeFirstLetterOfWord(key)}
                                    control={
                                        <Checkbox
                                            id={`setting-permissions-${role}-${key}`}
                                            checked={value}
                                            onChange={(e, checked) =>
                                                onChangePermissions(
                                                    role,
                                                    key,
                                                    checked,
                                                )
                                            }
                                        />
                                    }
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    )
}

export default SettingPermisons
